import { useState, useCallback } from 'react';

/**
 * Encapsulates the repeated page + limit + metadata + handler pattern.
 *
 * @param {object} [opts]
 * @param {number} [opts.initialPage=1]
 * @param {number} [opts.initialLimit=10]
 * @returns {{
 *   page: number,
 *   limit: number,
 *   pagination: { page: number, limit: number, total: number, totalPages: number },
 *   setPagination: Function,
 *   setPage: Function,
 *   handleLimitChange: Function,
 * }}
 */
export function usePagination({ initialPage = 1, initialLimit = 10 } = {}) {
  const [page, setPage] = useState(initialPage);
  const [limit, setLimit] = useState(initialLimit);
  const [pagination, setPagination] = useState({
    page: initialPage,
    limit: initialLimit,
    total: 0,
    totalPages: 1,
  });

  const handleLimitChange = useCallback((newLimit) => {
    setLimit(newLimit);
    setPage(1);
  }, []);

  return { page, setPage, limit, setLimit, pagination, setPagination, handleLimitChange };
}
